import { useState } from "react";

const faqs = [
  {
    q: "What is HipoBuy 2026?",
    a: "HipoBuy 2026 (hipobuy2026.net) is a trusted guide and resource website for top-quality fashion shopping. We connect fashion enthusiasts with high-quality products through our partner store repsw2c.com, offering shoes, clothing, accessories, and more at competitive prices.",
  },
  {
    q: "How does HipoBuy shipping work?",
    a: "HipoBuy shipping is handled through our partner store repsw2c.com. Orders are processed within 1-3 business days and shipped worldwide. Standard delivery takes 7-15 business days, while express shipping options are available for faster delivery. All orders include tracking information.",
  },
  {
    q: "What product categories does HipoBuy 2026 offer?",
    a: "HipoBuy 2026 covers a wide range of fashion categories including Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear/Underpants, Jerseys, and Accessories. New products are added regularly to keep up with the latest fashion trends.",
  },
  {
    q: "Are HipoBuy 2026 products good quality?",
    a: "Yes! HipoBuy 2026 partners exclusively with verified sellers who meet strict quality standards. We provide detailed product descriptions and quality checks to ensure customer satisfaction on every order.",
  },
  {
    q: "What payment methods are accepted?",
    a: "Our partner store repsw2c.com accepts multiple payment methods including major credit cards, PayPal, and other secure payment options. All transactions are encrypted and processed through secure payment gateways to protect your financial information.",
  },
  {
    q: "Can I return or exchange my HipoBuy order?",
    a: "Yes, returns and exchanges are accepted within 30 days of delivery for items in their original condition. Please visit our partner store repsw2c.com for detailed return instructions. Customer satisfaction is our top priority at HipoBuy 2026.",
  },
  {
    q: "Does HipoBuy 2026 ship internationally?",
    a: "Absolutely! HipoBuy 2026 ships to customers worldwide through our partner store repsw2c.com. We offer competitive international shipping rates with full tracking. Delivery times vary by location, typically ranging from 7-20 business days for international orders.",
  },
  {
    q: "How do I find the right size on HipoBuy 2026?",
    a: "Each product listing on repsw2c.com includes detailed sizing charts and measurements. We also have comprehensive sizing guides in our blog section to help you find the perfect fit. When in doubt, we recommend sizing up for the best comfort.",
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-20 md:py-24 bg-stone-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          {/* Left sticky header */}
          <div className="lg:col-span-2">
            <div className="lg:sticky lg:top-24">
              <div className="flex items-center gap-3 mb-4">
                <span className="h-px w-8 bg-amber-500"></span>
                <span className="text-amber-500 text-xs font-bold uppercase tracking-[0.2em]">FAQ</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-black leading-tight mb-5">
                Frequently<br />Asked<br />
                <span className="text-amber-400">Questions</span>
              </h2>
              <p className="text-stone-400 text-sm leading-relaxed mb-8">
                Everything you need to know about shopping with HipoBuy 2026. Can&apos;t find your answer?
              </p>
              <a
                href="https://repsw2c.com/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-amber-500 hover:bg-amber-400 text-white font-bold rounded-full transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                Visit Main Store
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-external-link-line"></i>
                </div>
              </a>

              {/* Mini stats */}
              <div className="grid grid-cols-2 gap-4 mt-10">
                {[
                  { v: "50K+", l: "Happy Customers" },
                  { v: "4.9★", l: "Average Rating" },
                  { v: "30d", l: "Return Policy" },
                  { v: "24/7", l: "Support" },
                ].map((s) => (
                  <div key={s.l} className="bg-stone-900 rounded-xl p-4 border border-stone-800">
                    <div className="text-xl font-black text-amber-400">{s.v}</div>
                    <div className="text-stone-500 text-xs mt-0.5">{s.l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: accordion */}
          <div className="lg:col-span-3 space-y-3">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className={`rounded-xl border transition-all duration-300 overflow-hidden ${
                  openIdx === idx
                    ? "border-amber-500/40 bg-stone-900"
                    : "border-stone-800 bg-stone-900/50 hover:border-stone-700"
                }`}
              >
                <button
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left cursor-pointer"
                >
                  <span className={`text-sm font-bold transition-colors ${openIdx === idx ? "text-amber-400" : "text-white"}`}>
                    {faq.q}
                  </span>
                  <div className={`w-7 h-7 flex items-center justify-center shrink-0 rounded-full transition-all ${openIdx === idx ? "bg-amber-500 rotate-45" : "bg-stone-800"}`}>
                    <i className="ri-add-line text-white text-sm"></i>
                  </div>
                </button>
                {openIdx === idx && (
                  <div className="px-6 pb-5">
                    <p className="text-stone-400 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
